import { delay, put, putResolve, select, takeEvery } from 'redux-saga/effects';
import { activateNotification, deactivateNotification, UTILITY_NOTIFICATION_ACK } from '../../actions/utility-actions';
import * as actions from '../../actions/utility-actions';
import { UserNotification } from '../../models/utilities/user-notification';
import { getNotifications } from '../../selectors/utility-selectors';

/**
 * Saga for getting the application service centers for the portal
 */
export function* acknowledgeNotification(action: IReduxAction) {

    // Our payload is just a notification ID
    const request = action.payload as string;

    // Get our notifications
    const storedNotifications = (yield select(getNotifications)) as UserNotification[];

    // Find our notification
    const existingIdx = storedNotifications.findIndex(( itm : UserNotification) => {
        return itm.id === request;
    });

    // This wasn't a valid notification for this user
    if (existingIdx === -1) {
        return;
    }

    // Indicate we're doing something with this one
    yield put(activateNotification(existingIdx));

    try {
        // Make the request to acknowledge the notification if not local
        if (!storedNotifications[existingIdx].isLocalNotification) {
            const rawResponse = yield putResolve(actions.fetch(`/notifications/${request}`, 'DELETE'));
        }
        
    }
    catch (err) {
        console.error(err);
        yield put(deactivateNotification(existingIdx));
    }    

    // For testing purposes only...
    // Move this into the above try and only remove if the ack was a success    
    const deleteCount = storedNotifications.splice(existingIdx, 1);
    if (deleteCount.length === 1) {
        yield put(actions.resetNotifications(storedNotifications));
    }

}

export function* getAcknowledgeNotificationsWatcher() {
    yield takeEvery(UTILITY_NOTIFICATION_ACK, acknowledgeNotification);
}
